import { useSelector } from 'react-redux';

import { SignalsGrid } from './signals-grid';
import { Content } from './signals-active.styled';

export const SignalsActive = () => {
  const signals = useSelector((store) => store.events.events);
  const getEventsArr = () => {
    const signalsList = [];
    if (signals) {
      for (let rack in signals) {
        let currentRack = signals[rack];
        for (let key in currentRack) {
          signalsList.push(currentRack[key]);
        }
      }
    }
    signalsList.sort((x, y) => {
      return y.timestamp - x.timestamp;
    });
    return signalsList;
  };

  return (
    <Content>
      <SignalsGrid signals={getEventsArr()} />
    </Content>
  );
};
